import React, { useState, useEffect } from 'react';
import tiktokService from '../services/tiktokService';
import TikTokComments from '../components/TikTokComments';

import Loading from '../components/Loading';
const TikTokCommentsPage = () => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await tiktokService.getAccounts();

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        setAccounts(response.data);
        setSelectedAccount(response.data[0]);
      } else {
        setError('No hay cuentas de TikTok conectadas');
      }
    } catch (err) {
      console.error('Error fetching TikTok accounts:', err);
      setError('Error al cargar las cuentas de TikTok. Por favor, conecta una cuenta primero.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loading fullScreen={false} mensaje="Cargando cuentas" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
        <div className="mt-4">
          <a
            href="/tiktok/connect/"
            className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
          >
            Conectar cuenta de TikTok
          </a>
        </div>
      </div>
    );
  }

  return (
    <div>
      {selectedAccount && (
        <TikTokComments
          tiktokUserId={selectedAccount.tiktok_user_id}
          accountName={`@${selectedAccount.username}`}
          accounts={accounts}
          onAccountChange={setSelectedAccount}
        />
      )}
    </div>
  );
};

export default TikTokCommentsPage;
